import request from '@/utils/request'

// 查询维修区域分页
export function fetchAreaPageList(query) {
  return request({
    url: '/upkeep/area/page',
    method: 'get',
    params: query,
  })
}

// 新增维修区域
export function addArea(data) {
  return request({
    url: '/upkeep/area/add',
    method: 'post',
    data: data,
  })
}

// 编辑维修区域
export function editArea(data) {
  return request({
    url: '/upkeep/area/edit',
    method: 'post',
    data: data,
  })
}

// 获取维修区域详情
export function getAreaDetail(id) {
  return request({
    url: `/upkeep/area/detail?id=${id}`,
    method: 'get',
  })
}

// 删除维修区域
export function deleteArea(idList) {
  return request({
    url: '/upkeep/area/delete',
    method: 'post',
    data: idList,
  })
}

// 启用/禁用维修区域
export function statusArea(data) {
  return request({
    url: '/upkeep/area/status',
    method: 'post',
    data: data,
  })
}
